import SimpleTextEditor from './TextAreaEditor';

export default SimpleTextEditor;
